export function isPremiumColumnVisible(visibleColumnIds: string[]): boolean {
  return visibleColumnIds.includes('premium');
}

export function filterPricingRows<T extends { label?: string }>(rows: T[], showOfflineAccess: boolean): T[] {
  if (showOfflineAccess) return rows;
  return rows.filter(row => row.label !== 'Offline access');
}

export function hasUnlimitedRole(groups?: string[] | null): boolean {
  return groups?.includes('ROLE_UNLIMITED') ?? false;
}

export function shouldShowFreeAcademicPlan(
  groups?: string[] | null,
  options?: { isCommercial?: boolean; shouldShowContactUs?: boolean },
): boolean {
  if (hasUnlimitedRole(groups)) return false;
  if (options?.isCommercial || options?.shouldShowContactUs) return false;
  return true;
}
